import { useEffect } from 'react';
import {
  useLazyCreateForm1572Query,
  useLazyGetForm1572DataQuery,
  useLazyPublishForm1572Query,
  useLazyUpdateForm1572Query,
  useLazyUpdateSignForm1572Query
} from 'src/services/Form1572';
import { useAppDispatch } from 'src/store/hooks';
import { updateUserAccess } from 'src/util/util';

export const useFrom1572 = () => {
  const dispatch: any = useAppDispatch();

  const [
    getForm1572QueryData,
    { isError: getForm1572IsError, data: form1572QueryData, error: getForm1572Error, isSuccess: getForm1572IsSuccess }
  ] = useLazyGetForm1572DataQuery();

  const [
    updateSignForm1572Query,
    {
      isError: updateSignForm1572QueryIsError,
      error: updateSignFormQuery1572Error,
      isSuccess: updateSignForm1572IsSuccess
    }
  ] = useLazyUpdateSignForm1572Query();

  const [
    updateForm1572Query,
    { isError: updateForm1572QueryIsError, error: updateFormQuery1572Error, isSuccess: updateForm1572IsSuccess }
  ] = useLazyUpdateForm1572Query();

  const [
    createForm1572Query,
    {
      isLoading: createForm1572QueryLoading,
      isError: createForm1572QueryIsError,
      error: createFormQuery1572Error,
      isSuccess: createForm1572IsSuccess
    }
  ] = useLazyCreateForm1572Query();

  const [
    publishForm1572Query,
    { isError: publishForm1572QueryIsError, error: publishFormQuery1572Error, isSuccess: publishForm1572IsSuccess }
  ] = useLazyPublishForm1572Query();

  useEffect(() => {
    if (
      getForm1572Error ||
      updateFormQuery1572Error ||
      publishFormQuery1572Error ||
      updateSignFormQuery1572Error ||
      createFormQuery1572Error
    ) {
      updateUserAccess(
        getForm1572Error ||
          updateFormQuery1572Error ||
          publishFormQuery1572Error ||
          updateSignFormQuery1572Error ||
          createFormQuery1572Error,
        dispatch
      );
    }
  }, [
    getForm1572Error,
    updateFormQuery1572Error,
    publishFormQuery1572Error,
    updateSignFormQuery1572Error,
    createFormQuery1572Error
  ]);

  return {
    form1572QueryData,
    getForm1572Error,
    getForm1572IsError,
    getForm1572QueryData,
    updateSignForm1572QueryIsError,
    updateSignForm1572Query,
    updateForm1572QueryIsError,
    updateForm1572Query,
    createForm1572QueryIsError,
    createForm1572QueryLoading,
    createForm1572Query,
    publishForm1572QueryIsError,
    publishForm1572Query,
    getForm1572IsSuccess,
    updateSignForm1572IsSuccess,
    updateForm1572IsSuccess,
    createForm1572IsSuccess,
    publishForm1572IsSuccess
  };
};
